<template>

    <el-tabs type="border-card" style='min-height:380px'>
    <el-tab-pane>
        <span slot="label"><i class="el-icon-folder-opened"></i> Inbox <small>(Files to Clent)</small></span>
        <p class='tx-12' style='color:gray;'>
            <i class='el-icon-info'></i>
             A Client will easily see that a file is waiting to be downloaded.
            <el-button type='text' v-on:click="grid=!grid" style="float:right;font-size:20px;padding:0px">
                <i :class="grid?'el-icon-s-fold':'el-icon-s-grid'"></i>
            </el-button>
        </p>
       
        <!-- <el-table
            ref="multipleTable"
            :data="tableData"
            height="350"
            style="width: 100%;font-size:13px"
            @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column
            label="Name"
            width="350">
            <template slot-scope="scope">
                <img :src='getSrcFromFileName(scope.row.name)' 
                alt="" style='width:20px;height:20px'>
                {{ scope.row.name }}
            </template>
            </el-table-column>
            <el-table-column
            property="uploaded"
            label="Uploaded"
            width="250">
            </el-table-column>
            <el-table-column
            property="size"
            label="Size"
            show-overflow-tooltip>
            </el-table-column>
            <el-table-column
            align="right">
            <template slot="header" style='font-size:60px'>
                <i class="el-icon-s-grid"></i>
            </template>
            <template>
                <i class="el-icon-view"></i>
                <i class="el-icon-download"></i>
                <i class="el-icon-delete"></i>
            </template>
                </el-table-column>
        </el-table> -->
            
        <div v-show="grid===false">
        <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            style="width: 100%;font-size:13px"
            @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column
            label="Name"
            width="450"
            sortable>
            <template slot-scope="scope">
                <img :src='getSrcFromFileName(scope.row.name)' 
                alt="" style='width:20px;height:20px;padding-right:5px'>
                <span style="font-weight:600">{{ scope.row.name }}</span>
            </template>
            </el-table-column>
            <el-table-column
            property="uploaded"
            label="Created"
            width="200"
            sortable>
            </el-table-column>
            <el-table-column
            property="size"
            label="Size"
            show-overflow-tooltip
            sortable>
            </el-table-column>
            <el-table-column
            align="right">
            <template slot-scope="scope">
                <!-- <i class="el-icon-view"></i> -->
                <el-button type='text' style="font-size:12px" v-on:click="download({'file_name':scope.row.name,'file_id':scope.row.id})">
                    <i class="el-icon-download"></i>
                </el-button>
                <!-- <i class="el-icon-delete"></i> -->
            </template>
                </el-table-column>
        </el-table>
        <div class='mg-t-10'>
            <el-button style='float:right' size='small' @click="multiDownload()">Download Selected</el-button>
            <!-- <el-button style='float:right;margin-right:5px' size='small' @click="toggleSelection()">Delete Selected</el-button> -->
        </div>
        </div>
        <table v-show="grid===true">
            <tr v-for="(row,index) in sliceList(tableData,4)" :key="index">
            <td v-for="(item,i) in row" :key="i">																										<el-card :body-style="{ padding: '0px' }" align="center" style="font-size:12px">
                    <img :src='getSrcFromFileName(item.name)' alt="" style='width:60px;height:60px'>
                    <div style="padding: 14px;">
                        <span style="font-weight:600">{{item.name}}</span>
                        <div class="bottom clearfix">
                            <el-row>
                                <span style="font-size:10px">Created: {{item.uploaded}}</span>
                            </el-row>
                            <el-row>
                                <!-- <i class="el-icon-view"></i> -->
                                <el-button type="text" class="button" v-on:click="download({'file_name':item.name,'file_id':item.id})">
                                    <i class="el-icon-download"></i>
                                </el-button>
                                <!-- <i class="el-icon-delete"></i> -->
                            </el-row>
                        </div>
                    </div>
                </el-card>
            </td>
            </tr>
        </table>

        
    </el-tab-pane>
    </el-tabs>
   
</template>
<script>
import pdf from "../../../assets/img/new/pdf.png";
import doc from "../../../assets/img/new/doc.png";
import xls from "../../../assets/img/new/xls.png";
import csv from "../../../assets/img/new/csv.png";
import txt from "../../../assets/img/new/txt.png";
import zip from "../../../assets/img/new/zip.png";
import other from "../../../assets/img/new/file.png";
export default {
    name: 'strategy',
    components: {

    },
    data(){
        return{
            filesrc: {
                'pdf':pdf,
                'doc':doc,
                'xls':xls,
                'csv':csv,
                'txt':txt,
                'zip':zip,
                'other':other
            },
            fileList: [{
                name: 'document_1.pdf',
                url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }, {
                name: 'document_2.doc',
                url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
            }],
            tableDataSample: [{
                uploaded: '03/09/2020 03:30 PM',
                name: 'sample_document_1.doc',
                size: '3.1MB'
                }, {
                uploaded: '09/11/2020 05:21 PM',
                name: 'sample_document_2.pdf',
                size: '20KB'
                }, {
                uploaded: '02/06/2020 09:35 AM',
                name: 'sample_document_3.xls',
                size: '2.8MB'
                }, {
                uploaded: '08/06/2021 09:20 AM',
                name: 'sample_document_4.xls',
                size: '68KB'
                }, {
                uploaded: '29/06/2021 09:26 AM',
                name: 'sample_document_5.xls',
                size: '93KB'
                }
            ],
            tableData:[],
            multipleSelection: [],
            loading:true,
            grid:false,
        }
    },
    computed: {
        sliceList() {
            return function (data,count) {
            if (data != undefined) {
                let index = 0;
                let arrTemp = [];
                for (let i = 0; i < data.length; i++) {
                index = parseInt(i / count);
                if (arrTemp.length <= index) {
                    arrTemp.push([]);
                }
                arrTemp[index].push(data[i])
                }
                return arrTemp
            }
            }
        }
    },
    created(){
        this.getFileDict();
    },
    methods:{
        getFileDict(){
            this.$api.funddashboard_api.documents(this.$route.params.fund_code,{'folder':'inbox'}).then(response =>{
                this.tableData = response.data['files_dict']
                this.loading = false
            });
        },
        download(params){
            this.$api.funddashboard_api.download(this.$route.params.fund_code,params).then(response =>{
                window.open(response.data['file_url'], '_blank');
            });
        },
        multiDownload(){
            for(let item of this.multipleSelection){
                this.download({'file_name':item.name,'file_id':item.id})
            }
        },
        getSrcFromFileName(filename){
            const suffix = filename.slice(-3)
            if(suffix==="pdf"){
                return this.filesrc.pdf;
            }else if(suffix==="doc"){
                return this.filesrc.doc;
            }else if(suffix==="txt"){
                return this.filesrc.txt;
            }else if(suffix==="xls"){
                return this.filesrc.xls;
            }else if(suffix==="csv"){
                return this.filesrc.csv;
            }else if(suffix==="zip"){
                return this.filesrc.zip;
            }else{
                return this.filesrc.other;
            }
                              
        },
        submitUpload() {
            this.$refs.upload.submit();
        },
        handleRemove(file, fileList) {
            this.fileList = fileList.slice(-3);
        },
        handlePreview(file) {
            console.log(file);
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
            } else {
            this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
}
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: black;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: black;
}
.el-upload-dragger .el-upload__text em {
    color: #3366ff;
    font-style: normal;
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #3366ff;
    border-radius: 6px;
    box-sizing: border-box;
    width: 280px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>
